module.exports = __webpack_public_path__ + "img/sdk2.d67c0fd4.png";